"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyPartyEntityTypes = exports.InvestorEntityTypes = void 0;
exports.isInvestorEntityType = isInvestorEntityType;
exports.isKeyPartyEntityType = isKeyPartyEntityType;
exports.InvestorEntityTypes = {
    REVOCABLE_TRUST: 'revocable-trust',
    IRREVOCABLE_TRUST: 'irrevocable-trust',
    LIMITED_GENERAL_PARTNERSHIP: 'limited-partnership/general-partnership',
    JOINT_ACCOUNT: 'joint-account',
    NON_PROFIT_FOUNDATION: 'non-profit-foundation',
    FOR_PROFIT_FOUNDATION: 'for-profit-foundation',
    FUND: 'fund',
    LLC: 'llc',
    CORPORATION: 'corporation',
    OTHER: 'other',
};
function isInvestorEntityType(param) {
    return Object.values(exports.InvestorEntityTypes).includes(param);
}
exports.KeyPartyEntityTypes = {
    REVOCABLE_TRUST: 'revocable-trust',
    IRREVOCABLE_TRUST: 'irrevocable-trust',
    LIMITED_GENERAL_PARTNERSHIP: 'limited-partnership/general-partnership',
    NON_PROFIT_FOUNDATION: 'non-profit-foundation',
    FOR_PROFIT_FOUNDATION: 'for-profit-foundation',
    FUND: 'fund',
    LLC: 'llc',
    CORPORATION: 'corporation',
    OTHER: 'other',
};
function isKeyPartyEntityType(param) {
    return Object.values(exports.KeyPartyEntityTypes).includes(param);
}
//# sourceMappingURL=entities.js.map